<div class="flex flex-col gap-2">
  <div
    class="flex gap-2 text-on-surface-subtle dark:text-on-surface-darkmode items-center justify-center h-10"
  >
    <h2 class="flex-1 text-sm pe-2 min-w-0">
      <ng-content select="[slot=title]" />
    </h2>
    <ng-content select="[slot=header]" />
  </div>

  <ng-content />
</div>
